import '../../App.css';
import './IndexStorage.css';
import React, { useEffect, useState, useCallback, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col } from 'reactstrap';
import i18n from "i18n-react";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import DefaultModal from '../../components/DefaultModal';
import { toastFunction } from '../../components/mainFunctions';
import * as FaIcons from "react-icons/fa";
import ProgressBar from 'react-bootstrap/ProgressBar';
import { stopPropagation } from "../../components/SidebarFunctions";
import DefaultSpinner from '../../components/DefaultSpinner';
import { useStorage } from '../../hooks/useStorage';
import { useMultimedia } from '../../hooks/useMultimedia';
import BulkActionsBar from '../../components/ui/ActionsBuitton/BulkActionsBar';
import PropTypes from 'prop-types';

export const url = process.env.REACT_APP_API_URL;

const IndexStorage = (props) => {


  const { instanceType, independent, token, language } = props;

  const [modalContent, setModalContent] = useState("");
  const [spinner, setSpinner] = useState("");
  const [viewMode, setViewMode] = useState("index");
  const [itemsToShow, setItemsToShow] = useState(8);
  const observerRef = useRef(null);

  const {
    storageUsed, totalStorage, percentageUsedStorage, classPercentageStorage,
    extraStorageList, currentExtraStorageId, currentExtraStorageSize,
    selectedPlanId, setSelectedPlanId,
    getStorageSize, manageStorage: fetchManageStorage, confirmNewExtraStorage, confirmSuspendExtraStorage
  } = useStorage({ url, setSpinner, setModalContent });

  const handleStorageUpdate = useCallback(() => {
    getStorageSize();
  }, [getStorageSize]);

  const {
    startDate, setStartDate, endDate, setEndDate,
    multimediaList, multimediaChecked, checkAll,
    extraStorageIndex,
    toggleCheckImage, toggleCheckAll, deselectAll,
    executeDownloadAllMultimedia, downloadImages, executeDeleteMultimedia
  } = useMultimedia({ url, setSpinner, setModalContent, onUpdateStorage: handleStorageUpdate });


  useEffect(() => {
    setItemsToShow(8);
  }, [multimediaList]);

  useEffect(() => {
    if (multimediaList.length === 0 || itemsToShow >= multimediaList.length) return;

    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        setItemsToShow((prev) => prev + 8);
      }
    }, {
      rootMargin: '150px',
      threshold: 0.1
    });

    if (observerRef.current) {
      observer.observe(observerRef.current);
    }

    return () => observer.disconnect();
  }, [multimediaList, itemsToShow]);

  useEffect(() => {
    if (token) {
      localStorage.setItem('auth_token', token);
    }
  }, [token]);

  useEffect(() => {
    const tokenInput = document.querySelector("#token");
    if (tokenInput && token) {
      tokenInput.value = token;
    }

    setSpinner(<DefaultSpinner instanceType={instanceType} independent={independent} />);
    extraStorageIndex();
    getStorageSize();

    const adjustHeight = () => {
      const nav = document.querySelector("#nav-top")?.offsetHeight || 0;
      const navbar = document.querySelector(".navbarT")?.offsetHeight || 0;
      const altura = window.innerHeight - nav - navbar - 90;
      const bodyContent = document.querySelector("#bodyContent");
      if (bodyContent) {
        bodyContent.style.maxHeight = altura + "px";
        bodyContent.style.height = altura + "px";
      }
    };
    setTimeout(adjustHeight, 100);
    window.addEventListener('resize', adjustHeight);
    return () => window.removeEventListener('resize', adjustHeight);
  }, []);


  const handleCallback = (start, end) => {
    setStartDate(start);
    setEndDate(end);
  };

  const showModal = (title, content, buttons) => {
    setModalContent("");

    const createModalButton = (btn) => {
      const handleClick = btn.function
        ? () => { btn.function(); setModalContent(""); }
        : () => setModalContent("");

      return {
        ...btn,
        function: handleClick
      };
    };

    setTimeout(() => {
      const enhancedButtons = buttons.map(createModalButton);

      setModalContent(
        <DefaultModal
          show={true}
          title={title}
          content={content}
          buttons={enhancedButtons}
          closeFunction={() => setModalContent("")}
        />
      );
    }, 10);
  };

  const openManageStorage = () => {
    setViewMode("manage");
    setSpinner(<DefaultSpinner instanceType={instanceType} independent={independent} />);
    fetchManageStorage();
  };

  const closeManageStorage = () => {
    setViewMode("index");
    setSpinner(<DefaultSpinner instanceType={instanceType} independent={independent} />);
    extraStorageIndex();
    getStorageSize();
  };

  const selectNewPlan = (e, plan) => {
    if (plan.id === currentExtraStorageId) {
      setSelectedPlanId(prev => prev === plan.id ? "" : plan.id);
    } else if (plan.storageSize < currentExtraStorageSize) {
      toastFunction(i18n.translate("the_plan_to_hire_must_be_greater_than_the_current_one"), "warning");
    } else {
      setSelectedPlanId(prev => prev === plan.id ? "" : plan.id);
    }
  };

  const getNewExtraStorage = () => {
    setModalContent("");
    const content = <div>{i18n.translate("confirm_activate_plan")}</div>;
    setTimeout(() => {
      const buttons = [
        { text: i18n.translate("default_confirm"), function: () => { setSpinner(<DefaultSpinner instanceType={instanceType} independent={independent} />); confirmNewExtraStorage(); } },
        { text: i18n.translate("cancel"), function: "" }
      ];
      showModal(i18n.translate("default_confirm"), content, buttons);
    }, 10);
  };

  const suspendExtraStorage = () => {
    setModalContent("");

    const content = <div>{i18n.translate("confirm_deactivate_plan")}</div>;

    const handleConfirmSuspend = () => {
      setSpinner(<DefaultSpinner instanceType={instanceType} independent={independent} />);
      confirmSuspendExtraStorage(() => closeManageStorage());
    };

    setTimeout(() => {
      const buttons = [
        {
          text: i18n.translate("default_confirm"),
          function: handleConfirmSuspend
        },
        {
          text: i18n.translate("cancel"),
          function: ""
        }
      ];

      showModal(i18n.translate("default_confirm"), content, buttons);
    }, 10);
  };

  const downloadDeleteViewImage = (map, e, action) => {
    stopPropagation(e);
    const getSelectedIds = () => {
      if (map) return [map.id];
      return multimediaChecked.map(m => m.id);
    };

    switch (action) {
      case "cancel":
        deselectAll();
        break;

      case "view": { // <-- Abrimos bloque léxico con llaves
        const content = (
          <div style={{ textAlign: 'center', padding: '10px' }}>
            <img
              alt={map.fileName}
              src={`data:image/${map.fileExtension || 'jpeg'};base64,${map.multimediaFile}`}
              style={{ maxWidth: '100%', maxHeight: '75vh', objectFit: 'contain', borderRadius: '6px' }}
            />
            <div style={{ marginTop: '8px', fontSize: '12px', color: '#6c757d' }}>
              <b>{map.fileName}</b> &nbsp;|&nbsp; {map.creationDate}
            </div>
          </div>
        );
        setTimeout(() => {
          const buttons = [{ text: i18n.translate("cancel"), function: "" }];
          showModal(map.fileName, content, buttons);
        }, 10);
        break;
      }

      case "downloadAll": {
        const contentDownload = <div>{i18n.translate("confirm_download_all", { cant: multimediaList.length })}</div>;
        setTimeout(() => {
          const buttons = [
            { text: i18n.translate("default_confirm"), function: () => { setSpinner(<DefaultSpinner instanceType={instanceType} independent={independent} />); executeDownloadAllMultimedia(); } },
            { text: i18n.translate("cancel"), function: "" }
          ];
          showModal(i18n.translate("default_confirm"), contentDownload, buttons);
        }, 10);
        break;
      }

      case "download":
        setSpinner(<DefaultSpinner instanceType={instanceType} independent={independent} />);
        downloadImages(getSelectedIds());
        break;

      case "delete": {
        const targetIds = getSelectedIds();
        const deleteCount = targetIds.length;
        const contentDelete = <div>{deleteCount === 1 ? i18n.translate("confirm_delete") : i18n.translate("confirm_delete_all", { cant: deleteCount })}</div>;
        setTimeout(() => {
          const buttons = [
            { text: i18n.translate("default_confirm"), function: () => { setSpinner(<DefaultSpinner instanceType={instanceType} independent={independent} />); executeDeleteMultimedia(targetIds); } },
            { text: i18n.translate("cancel"), function: "" }
          ];
          showModal(i18n.translate("default_confirm"), contentDelete, buttons);
        }, 10);
        break;
      }

      default:
        break;
    }
  };

  const domainLabel = (domain) => {
    const labels = {
      'v_tasks': i18n.translate("v_task"),
      'v_visit': i18n.translate("v_visit"),
      'v_office': i18n.translate("v_office"),
      "v_task_detail": i18n.translate("v_task_detail")
    };
    return labels[domain] || domain || '-';
  };

  const visibleMultimedia = multimediaList.slice(0, itemsToShow);

  return (
    <>
      {Boolean(spinner) && spinner}
      {modalContent}
      <br />
      <nav className='navbarT'>
        {viewMode === "manage" && (
          <Row style={{ marginBottom: '10px' }} className='rowManageStorage'>
            <Col>
              <button className='buttonMzateSecondary' onClick={closeManageStorage}>
                <FaIcons.FaLongArrowAltLeft />
                <span>{i18n.translate("default_back")}</span>
              </button>
            </Col>
            {selectedPlanId !== "" && selectedPlanId != currentExtraStorageId && (
              <Col id='colConfirmNewPlan'>
                <button className='buttonMzatePrimary' onClick={getNewExtraStorage}>
                  <FaIcons.FaCheck />
                  <span>{i18n.translate("default_activate")}</span>
                </button>
              </Col>
            )}
            {selectedPlanId == currentExtraStorageId && (
              <Col id='colSuspendPlan'>
                <button className='buttonMzatePrimary' onClick={suspendExtraStorage}>
                  <FaIcons.FaTimes />
                  <span>{i18n.translate("default_suspend")}</span>
                </button>
              </Col>
            )}
          </Row>
        )}

        {viewMode === "index" && (
          <>

            <Row className="rowIndexStorage align-items-center">
              <Col sm={12} md={4} className="mb-2">
                <div className="d-flex gap-2">
                  <DateRangePicker
                    initialSettings={{
                      startDate: startDate, endDate: endDate,
                      locale: {
                        applyLabel: language === 'es' ? 'Aplicar' : 'Apply',
                        cancelLabel: language === 'es' ? 'Cancelar' : 'Cancel',
                      }
                    }}
                    onCallback={handleCallback}>
                    <input type="text" readOnly className="form-control inputStandard" style={{ fontSize: "12px", cursor: "pointer" }} />
                  </DateRangePicker>
                  <button className='buttonMzateSecondary' onClick={() => { setSpinner(<DefaultSpinner instanceType={instanceType} independent={independent} />); extraStorageIndex(); }}>
                    {i18n.translate("default_search")}
                  </button>
                </div>
              </Col>
              <Col sm={12} md={4} className="text-center mb-2">
                <div className="small mb-1">
                  <FaIcons.FaCloud /> {totalStorage > 1024 ? `${(storageUsed / 1024).toFixed(2)} Gb` : `${storageUsed.toFixed(2)} Mb`}
                  {' '}{i18n.translate("default_of")}{' '}
                  {totalStorage > 1024 ? `${totalStorage / 1024} Gb` : `${totalStorage} Mb`}
                </div>
                <ProgressBar
                  animated
                  now={percentageUsedStorage}
                  variant={classPercentageStorage}
                  label={`${percentageUsedStorage}%`}
                  style={{ minWidth: '2rem' }}
                />
              </Col>
              <Col sm={12} md={4} className="text-end">
                <button className='buttonMzateSecondary w-100-mobile' onClick={openManageStorage}>
                  {i18n.translate("manage_storage")}
                </button>
              </Col>
            </Row>

            <br />
            {viewMode === "index" && (
              <BulkActionsBar
                selectedCount={multimediaChecked.length}
                totalImages={multimediaList.length}
                checkAll={checkAll}
                onToggleAll={toggleCheckAll}
                actions={{
                  downloadAll: (e) => downloadDeleteViewImage("", e, "downloadAll"),
                  downloadSelected: (e) => downloadDeleteViewImage("", e, "download"),
                  deleteSelected: (e) => downloadDeleteViewImage("", e, "delete"),
                  cancel: (e) => downloadDeleteViewImage("", e, "cancel")
                }}
              />
            )}
          </>
        )}
      </nav>

      <div id='bodyContent' className='bodyContent mt-3'>


        {viewMode === "index" && (
          <Row className="rowIndexStorage">
            {visibleMultimedia.map(mList => {
              const isChecked = multimediaChecked.some(m => m.id === mList.id);
              return (
                <Col xs={6} sm={6} md={4} lg={3} key={mList.id} className="mb-4">
                  <div className={`storage-card ${isChecked ? 'checked border-primary' : ''}`} style={{ position: 'relative' }}>
                    <div>


                      <button
                        type="button"
                        className="card-image-wrapper plain-button"
                        style={{ cursor: 'pointer', background: 'none', border: 'none', padding: 0, width: '100%', textAlign: 'left', display: 'block' }}
                        onClick={(e) => { stopPropagation(e); toggleCheckImage(mList); }}
                        aria-label={`${String(i18n.translate("default_select") || "Seleccionar")} ${mList.fileName}`}
                        aria-pressed={isChecked}
                      >
                        <div className="card-select-overlay">
                          <FaIcons.FaCheckCircle className="check-icon" />
                        </div>

                        <img
                          className='card-img'
                          src={`data:image/${mList.fileExtension || 'jpeg'};base64,${mList.multimediaFile}`}
                          alt={mList.fileName}
                        />

                        {isChecked && (
                          <FaIcons.FaCheckCircle
                            className="position-absolute top-0 start-0 m-2 text-primary"
                            style={{ fontSize: '1.5rem', zIndex: 10, background: 'white', borderRadius: '50%' }}
                          />
                        )}
                      </button>

                      <div className='optionImgThumbnail'>
                        <button
                          type="button"
                          className='divOptionImgThumbnail plain-button'
                          title='Descargar'
                          onClick={(e) => { stopPropagation(e); downloadDeleteViewImage(mList, e, "download"); }}
                        >
                          <FaIcons.FaDownload size={14} />
                        </button>
                        <button
                          type="button"
                          className='divOptionImgThumbnail plain-button'
                          title='Eliminar'
                          onClick={(e) => { stopPropagation(e); downloadDeleteViewImage(mList, e, "delete"); }}
                        >
                          <FaIcons.FaTrash size={14} />
                        </button>
                        <button
                          type="button"
                          className='divOptionImgThumbnail plain-button'
                          title='Ver completa'
                          onClick={(e) => { stopPropagation(e); downloadDeleteViewImage(mList, e, "view"); }}
                        >
                          <FaIcons.FaSearchPlus size={14} />
                        </button>
                      </div>

                    </div>

                    <div className='card-footer-info p-2'>
                      <div className="d-flex justify-content-between align-items-center">
                        <span className={`badge-domain ${mList.domain}`} style={{ fontSize: '10px' }}>{domainLabel(mList.domain)}</span>
                        <span className='text-muted' style={{ fontSize: '10px' }}>{mList.creationDate}</span>
                      </div>
                    </div>
                  </div>
                </Col>
              );
            })}
          </Row>
        )}

        {itemsToShow < multimediaList.length && (
          <div
            ref={observerRef}
            className="w-100 text-center py-4"
            style={{ minHeight: '60px', color: '#6c757d', fontWeight: 'bold' }}
          >
            {i18n.translate("default_loading") || "Cargando más elementos..."}
          </div>
        )}


        {viewMode === "manage" && (
          <Row className='rowManageStorage'>
            {extraStorageList.map((list) => {
              const isSelected = list.id === selectedPlanId;
              const isCurrent = list.id === currentExtraStorageId;

              return (
                <Col key={list.id} sm={6} md={3} lg={3} xl={3} className="mb-3">
                  {/* Cambiamos el div contenedor por un button nativo */}
                  <button
                    type="button"
                    className={`plansList ${isSelected ? 'plan-selected' : ''} ${isCurrent ? 'plan-current' : ''}`}
                    onClick={(e) => selectNewPlan(e, list)}
                    style={{
                      background: 'none',
                      border: 'none',
                      padding: 0,
                      width: '100%',
                      textAlign: 'left',
                      display: 'block',
                      cursor: 'pointer'
                    }}
                    aria-label={`${list.moduleDescription} - ${(list.storageSize / 1024).toFixed(2)} Gb por ${list.price} USD`}
                    aria-pressed={isSelected}
                  >
                    <div className='storageNumber'>{(list.storageSize / 1024).toFixed(2)}</div>
                    <div className='plan-details'>
                      <div className='plan-title'>{list.moduleDescription}</div>
                      <div className='plan-price'>{list.price} USD</div>
                    </div>

                    {(isSelected || isCurrent) && (
                      <div className="plan-check-icon">
                        <FaIcons.FaCheckCircle
                          size={22}
                          color={isCurrent ? '#a1d06d' : '#007bff'}
                        />
                      </div>
                    )}
                  </button>
                </Col>
              )
            })}
          </Row>
        )}
      </div>


    </>
  );
};

IndexStorage.propTypes = {
  instanceType: PropTypes.string,
  independent: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,
  language: PropTypes.string
};

export default IndexStorage;